// extracted by mini-css-extract-plugin
export default {"title":"Cor2wJUmDK"};